import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useCampaignContestDetailFetch = (accountId?: string, campaignId?: string) => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)
  const [isInitialLoading, setInitialLoading] = useState(true)

  const campaignData = useQuery({
    queryKey: queryKeys.campaign.contestDetail(accountId, campaignId, locale),
    queryFn: () => apiClient.getTradingAccountContestCampaignById(accountId!, campaignId!, locale),
    enabled: !!accountId && !!campaignId,
  })

  const days = useQuery({
    queryKey: queryKeys.campaign.contestDays(accountId, campaignId),
    queryFn: () => apiClient.getTradingAccountContestCampaignDays(accountId!, campaignId!),
    enabled: !!accountId && !!campaignId,
  })

  const drawdown = useQuery({
    queryKey: queryKeys.campaign.contestDrawdown(accountId, campaignId),
    queryFn: () => apiClient.getTradingAccountContestCampaignDrawdown(accountId!, campaignId!),
    enabled: !!accountId && !!campaignId,
  })

  const isLoading = [campaignData.isLoading, days.isLoading, drawdown.isLoading].some(Boolean)

  useEffect(() => {
    if (isInitialLoading) setInitialLoading(isLoading)
  }, [isInitialLoading, isLoading])

  return {
    campaignData: { data: campaignData.data, isLoading: campaignData.isLoading },
    days: { data: days.data, isLoading: days.isLoading },
    drawdown: { data: drawdown.data, isLoading: drawdown.isLoading },
    isLoading,
    isInitialLoading,
  }
}
